import axiosInstance from './axiosInstance'

export const login = (email, password) => {
  return axiosInstance.post('/auth/login', {
    email, password
  })
}

export const getCurrentUser = () => {
  return axiosInstance.get('/auth/getCurrentUser')
}

export const changePassword = (currentPassword, newPassword) => {
  return axiosInstance.post('/auth/changePassword', { currentPassword, newPassword })
}

export const checkPassword = (password) => {
  return axiosInstance.post('/auth/checkPassword', { password })
}
